<script>
    export default {
        name: 'AuthGrant',
        render: () => null,
    }
</script>
